import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import mqBreakpoints from 'rp-mq-breakpoints';
import Tabs from '../../components/Catalogue/Tabs';
import Tab from '../../components/Catalogue/Tab';
import LotsFound from '../../containers/Catalogue/LotsFound';
import HorseFilters from '../../containers/Catalogue/HorseFilters';
import PedigreeFilters from '../../containers/Catalogue/PedigreeFilters';
import VendorBuyerFilters from '../../containers/Catalogue/VendorBuyerFilters';
import * as catalogueActions from '../../actions/catalogue';
import {
    catalogueStateKey,
    isCommonFiltersTabDisabled,
    isHorseFiltersTabDisabled,
    isCatalogueUpcoming,
    isFilteringEmpty,
} from '../../helpers/catalogueUtils';

class Refinement extends PureComponent {
    static propTypes = {
        refinement: PropTypes.object.isRequired,
        applyDefaultCatalogueRefinement: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            activeTabIndex: 0,
            active: false,
            bpCode: mqBreakpoints.current().code,
        };
        this.upcoming = isCatalogueUpcoming();

        this.toggle = this.toggle.bind(this);
        this.handleBreakpointChange = this.handleBreakpointChange.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
    }

    componentWillUnmount() {
        window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
    }

    handleBreakpointChange(e) {
        this.setState({
            bpCode: e.detail.breakpoint.code,
        });
    }

    toggle() {
        this.setState({
            active: !this.state.active
        });
    }

    handleTabChange(activeTabIndex) {
        this.setState({ activeTabIndex });
    }

    isCommonFiltersTabDisabled() {
        return isCommonFiltersTabDisabled(this.props.refinement);
    }

    renderRefinementSwitcher() {
        return (
            <div className="sales__catalogueRefineBtnWrp">
                <button
                    className="ui-btn ui-btn_tiertiary sales__catalogueRefineBtn"
                    onClick={this.toggle}
                >
                    {this.state.active
                        ? <span>Close</span>
                        : <span>Refine Catalogue</span>
                    }
                </button>
            </div>
        );
    }

    renderVendorBuyerTabTitle() {
        return (
            <span>
                <span className="hidden-sm-down">Vendor / Buyer</span>
                <span className="hidden-xs-down hidden-md-up">Ven / Buy</span>
                <span className="hidden-sm-up">V / B</span>
            </span>
        );
    }

    renderResetButton() {
        return (
            <button
                onClick={this.props.applyDefaultCatalogueRefinement}
                className="ui-btn ui-btn_secondary sales__catalogueRefineReset"
                disabled={isFilteringEmpty(this.props.refinement)}
            >
                <span>Reset</span>
            </button>
        );
    }

    renderLotsFound() {
        return (<LotsFound />);
    }

    renderTabs() {
        const { active, bpCode, activeTabIndex } = this.state;

        if (!active && ['n', 'xn'].indexOf(bpCode) > -1) {
            return null;
        }

        return (
            <div className="sales__catalogueRefineTabsWrp">
                <Tabs
                    switcherAdditionalChildren={this.renderResetButton()}
                    contentAdditionalChildren={this.renderLotsFound()}
                    activeTabIndex={activeTabIndex}
                    onTabChange={this.handleTabChange}
                >
                    <Tab
                        title="Horse"
                        buttonClassName="sales__catalogueRefineTabHorse"
                        disabled={isHorseFiltersTabDisabled(this.props.refinement)}
                    >
                        <HorseFilters />
                    </Tab>
                    <Tab
                        title="Pedigree"
                        buttonClassName="sales__catalogueRefineTabPedigree"
                        disabled={this.isCommonFiltersTabDisabled()}
                    >
                        <PedigreeFilters />
                    </Tab>
                    <Tab
                        title={this.upcoming ? 'Vendor' : this.renderVendorBuyerTabTitle()}
                        buttonClassName="sales__catalogueRefineTabVendor"
                        disabled={this.isCommonFiltersTabDisabled()}
                    >
                        <VendorBuyerFilters />
                    </Tab>
                </Tabs>
            </div>
        );
    }

    render() {
        return (
            <div className="sales__catalogueRefineWrp">
                {this.renderRefinementSwitcher()}
                <div className="sales__catalogueRefineHeader">
                    Refine Catalogue
                </div>
                {this.renderTabs()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state[catalogueStateKey];
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(catalogueActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Refinement);



// WEBPACK FOOTER //
// ./src/js/containers/Catalogue/Refinement.js